export default function (Component) {
      Component.options.__docs = "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n```jsx\n\n<mks-lang-picker :langs=\"['fr', 'en', 'es']\" active=\"en\"></mks-lang-picker>\n\n```\n"
    }